import { render, staticRenderFns } from "./MartixChoiceValue.vue?vue&type=template&id=64d3bb51&scoped=true"
import script from "./MartixChoiceValue.vue?vue&type=script&lang=js"
export * from "./MartixChoiceValue.vue?vue&type=script&lang=js"
import style0 from "./MartixChoiceValue.vue?vue&type=style&index=0&id=64d3bb51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d3bb51",
  null
  
)

export default component.exports